import React from 'react';
import Icon from '../../../components/AppIcon';

const InsertionPoint = ({ onClick }) => {
  return (
    <div className="group/insert relative flex items-center justify-center py-1">
      {/* Thin line */}
      <div className="absolute inset-x-0 top-1/2 h-px bg-border opacity-0 group-hover/insert:opacity-100 transition-opacity" />

      {/* Plus button */}
      <button
        onClick={onClick}
        className="relative z-10 w-7 h-7 rounded-full bg-primary text-primary-foreground flex items-center justify-center opacity-30 [@media(hover:hover)]:opacity-0 [@media(hover:hover)]:group-hover/insert:opacity-100 group-hover/insert:opacity-100 scale-90 [@media(hover:hover)]:scale-75 [@media(hover:hover)]:group-hover/insert:scale-100 group-hover/insert:scale-100 transition-all shadow-sm hover:shadow-md"
        aria-label="Добавить секцию"
        title="Добавить секцию"
      >
        <Icon name="Plus" size={16} />
      </button>
    </div>
  );
};

export default InsertionPoint;
